export default __webpack_public_path__ + "static/FS2S-InHub-190-63a514b84f258adabb3232b51259abc1.jpg";